// Styles
import "@mdi/font/css/materialdesignicons.css"; // Importieren der Material Design Icons
import "vuetify/styles"; // Importieren der Vuetify-Styles

// Vuetify
import { createVuetify } from "vuetify";

// Erstellen und Exportieren der Vuetify-Instanz mit der Konfiguration
export default createVuetify({
  theme: {
    defaultTheme: "light", // Standard-Theme setzen
    themes: {
      light: {
        colors: {
          primary: "#3d1b70", // Dunkles Lila (Logo-Farbe)
          secondary: "#fcc25e", // Goldgelb (Logo-Farbe)
          accent: "#fcc25e", // Akzentfarbe (Goldgelb)
          error: "#FF5252", // Fehlerfarbe
          info: "#2196F3", // Info-Farbe
          success: "#4CAF50", // Erfolgsfarbe
          warning: "#fcc25e", // Warnfarbe (Goldgelb)
          // Fügen Sie hier weitere Farbanpassungen hinzu
        },
      },
      dark: {
        colors: {
          primary: "#3d1b70", // Dunkles Lila
          secondary: "#fcc25e", // Goldgelb
          accent: "#fcc25e",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#fcc25e",
          // Fügen Sie hier weitere Farbanpassungen hinzu
        },
      },
    },
  },
  // Weitere Vuetify-Optionen hier einfügen
});
